// auth
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const LOGOUT = 'LOGOUT';

// session
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const CLEAR_SESSION_EXPIRED = 'CLEAR_SESSION_EXPIRED';

// theme
export const CHANGE_PRIMARY_COLOR = 'CHANGE_PRIMARY_COLOR';
export const CHANGE_THEME = 'CHANGE_THEME';

// companies
export const GET_COMPANIES_PENDING = 'GET_COMPANIES_PENDING';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR';

export const ADD_COMPANY_PENDING = 'ADD_COMPANY_PENDING';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_ERROR = 'ADD_COMPANY_ERROR';

export const CLEAR_NEWLY_ADDED_COMPANY = 'CLEAR_NEWLY_ADDED_COMPANY';

export const FILTER_COMPANIES_PENDING = 'FILTER_COMPANIES_PENDING';
export const FILTER_COMPANIES_SUCCESS = 'FILTER_COMPANIES_SUCCESS';
export const CLEAR_FILTER_COMPANIES = 'CLEAR_FILTER_COMPANIES';

// licences
export const GET_LICENCES_PENDING = 'GET_LICENCES_PENDING';
export const GET_LICENCES_SUCCESS = 'GET_LICENCES_SUCCESS';
export const GET_LICENCES_ERROR = 'GET_LICENCES_ERROR';

export const FILTER_LICENCES_PENDING = 'FILTER_LICENCES_PENDING';
export const FILTER_LICENCES_SUCCESS = 'FILTER_LICENCES_SUCCESS';
export const CLEAR_FILTER_LICENCES = 'CLEAR_FILTER_LICENCES';

// add licence
export const ADD_LICENCE_PENDING = 'ADD_LICENCE_PENDING';
export const ADD_LICENCE_SUCCESS = 'ADD_LICENCE_SUCCESS';
export const ADD_LICENCE_ERROR = 'ADD_LICENCE_ERROR';

export const CLEAR_NEWLY_ADDED_LICENCE = 'CLEAR_NEWLY_ADDED_LICENCE';

export const ADD_LICENCE_SELECT_COMPANY = 'ADD_LICENCE_SELECT_COMPANY';
export const ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS = 'ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS';
export const ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS = 'ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS';
export const ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS = 'ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS';
export const ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS = 'ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS';
export const ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS = 'ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS';
export const ADD_LICENCE_SET_AVAILABLE_COMPANIES = 'ADD_LICENCE_SET_AVAILABLE_COMPANIES';
export const ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT = 'ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT';
export const ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS = 'ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS';
export const ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY = 'ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY';
export const ADD_LICENCE_SELECT_PRODUCT = 'ADD_LICENCE_SELECT_PRODUCT';
export const ADD_LICENCE_SET_LICENCE_ELEMENTS = 'ADD_LICENCE_SET_LICENCE_ELEMENTS';


// side menu
export const COLLAPSE_SIDE_MENU = 'COLLAPSE_SIDE_MENU';
export const BREAK_SIDE_MENU = 'BREAK_SIDE_MENU';

// generic codebook
export const GET_GENERIC_CODEBOOK_PENDING = 'GET_GENERIC_CODEBOOK_PENDING';
export const GET_GENERIC_CODEBOOK_SUCCESS = 'GET_GENERIC_CODEBOOK_SUCCESS';
export const GET_GENERIC_CODEBOOK_ERROR = 'GET_GENERIC_CODEBOOK_ERROR';
export const SET_GENERIC_CODEBOOK_OPTIONS_MAP = 'SET_GENERIC_CODEBOOK_OPTIONS_MAP';
export const FILTER_GENERIC_CODEBOOK = 'FILTER_GENERIC_CODEBOOK';
export const SHOW_ADD_MODAL_GENERIC_CODEBOOK = 'SHOW_ADD_MODAL_GENERIC_CODEBOOK';
export const SHOW_EDIT_MODAL_GENERIC_CODEBOOK = 'SHOW_EDIT_MODAL_GENERIC_CODEBOOK';
export const ADD_GENERIC_CODEBOOK_PENDING = 'ADD_GENERIC_CODEBOOK_PENDING';
export const ADD_GENERIC_CODEBOOK_SUCCESS = 'ADD_GENERIC_CODEBOOK_SUCCESS';
export const ADD_GENERIC_CODEBOOK_ERROR = 'ADD_GENERIC_CODEBOOK_ERROR';
export const UPDATE_GENERIC_CODEBOOK_PENDING = 'UPDATE_GENERIC_CODEBOOK_PENDING';
export const UPDATE_GENERIC_CODEBOOK_SUCCESS = 'UPDATE_GENERIC_CODEBOOK_SUCCESS';
export const UPDATE_GENERIC_CODEBOOK_ERROR = 'UPDATE_GENERIC_CODEBOOK_ERROR';
export const GENERIC_CODEBOOK_DELETED = 'GENERIC_CODEBOOK_DELETED';
export const RESET_GENERIC_CODEBOOK_STATE = 'RESET_GENERIC_CODEBOOK_STATE';


